import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';

const Blog = () => {
  useSEO({
    title: 'NYC SEO & AI Trends Blog | NewYorkCitySEO.agency',
    description: 'Read our latest insights on How AI is changing SEO, GEO vs Traditional SEO, and the best strategies to rank your Manhattan or Brooklyn business.',
  });

  const posts = [
    {
      title: "How AI Is Changing SEO in NYC: The 2026 Outlook",
      category: "AI SEO",
      date: "Oct 15, 2025",
      excerpt: "Discover how ChatGPT and Google's SGE are altering consumer behavior in New York City, and why traditional keyword optimization is no longer enough to maintain visibility."
    },
    {
      title: "GEO vs Traditional SEO: What's the Difference?",
      category: "GEO",
      date: "Oct 02, 2025",
      excerpt: "Generative Engine Optimization focuses on entity building for Large Language Models. We break down the technical differences and why your brand needs both."
    },
    {
      title: "How to Rank Your NYC Business in ChatGPT Answers",
      category: "Technical SEO",
      date: "Sep 28, 2025",
      excerpt: "A step-by-step guide to structuring your data, building citation networks, and establishing the authority required to be recommended by conversational AI models."
    },
    {
      title: "Best SEO Strategies for Manhattan Law Firms",
      category: "Industry SEO",
      date: "Sep 15, 2025",
      excerpt: "The legal market in Manhattan is cutthroat. Learn how to leverage E-E-A-T, localized content hubs, and technical superiority to dominate the Local Map Pack."
    },
    {
      title: "Why Local SEO Matters More Than Ever in Brooklyn",
      category: "Local SEO",
      date: "Sep 01, 2025",
      excerpt: "With hyper-local search volume exploding, Brooklyn businesses must optimize for neighborhood-level intent to capture high-converting foot traffic."
    }
  ];

  return (
    <div className="pt-20 pb-24 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Insights & Strategy"
            title="The Forefront of Digital Search"
            description="Stay ahead of the algorithm. Our latest research, case studies, and strategic guides on dominating search in New York City."
          />
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {posts.map((post, i) => (
            <AnimatedSection key={i} delay={i * 0.1}>
              <article className="glass-panel rounded-2xl overflow-hidden border border-slate-800 hover:border-blue-500 transition-colors h-full flex flex-col cursor-pointer group">
                <div className="h-48 bg-slate-900 border-b border-slate-800 flex items-center justify-center overflow-hidden relative">
                   <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-purple-900/20 group-hover:scale-110 transition-transform duration-500"></div>
                   <span className="text-slate-600 font-bold text-xl uppercase tracking-widest relative z-10">NYC SEO</span>
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <div className="flex justify-between items-center mb-4 text-xs">
                    <span className="text-blue-400 font-semibold px-2 py-1 bg-blue-900/30 rounded">{post.category}</span>
                    <span className="text-slate-500">{post.date}</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-blue-400 transition-colors">{post.title}</h3>
                  <p className="text-slate-400 text-sm leading-relaxed mb-6 flex-grow">{post.excerpt}</p>
                  <div className="text-blue-500 font-semibold text-sm flex items-center mt-auto">
                    Read Article <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
                  </div>
                </div>
              </article>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;